import { SchdMessage } from '../decoders'
import { DeviceData } from '../models/deviceState'
import { extractSensorValue } from './sensors'
import { TMessageSigfoxOut } from '../entities/ric003'
import { BaseUnits } from '../common'

export function addReading(
  device: DeviceData,
  message: TMessageSigfoxOut,
  sensorId: string,
  reading: number | string
) {
  const sensor = device.config.sensors[sensorId]

  const units = sensor?.units
  let sensorType = sensor?.sensorType

  if (!device.readings[sensorId]) {
    device.readings[sensorId] = {
      metadata: {
        sensorType: sensorType || sensorId,
        units: units || determineUnits(sensorId),
        lastRawMessageId: message.MSG_RAW_ID,
        lastReadingTimestamp: message.SIGFOX_TIME,
        latestOverallReadingTimestamp: message.SIGFOX_TIME,
      },
      data: {},
    }
  }

  device.readings[sensorId].data[message.SIGFOX_TIME] = reading
  device.readings[sensorId].metadata.lastRawMessageId = message.MSG_RAW_ID
  device.readings[sensorId].metadata.lastReadingTimestamp = message.SIGFOX_TIME
  device.readings[sensorId].metadata.latestOverallReadingTimestamp = Math.max(
    ...Object.keys(device.readings[sensorId].data).map((x) => parseInt(x))
  )
}

export function interpretScheduledReading(
  device: DeviceData,
  message: SchdMessage
) {
  const result: { [key: string]: number } = {}

  const sensors = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2']

  sensors.map((index) => {
    if (device.config.sensors) {
      const sensor = device.config.sensors[index]

      if (sensor && sensor.enabled) {
        const value = extractSensorValue(
          sensor,
          message.sensorReadings[index],
          device.config.frequency.schd
        )
        // console.log(
        //   'sensor',
        //   sensor.sensorType,
        //   index,
        //   message.sensorReadings[index],
        //   value
        // )

        if (value !== undefined) {
          result[index] = value
        }
      }
    }
  })

  return result
}

function determineUnits(sensor: string): BaseUnits {
  switch (sensor) {
    case 'Battery':
      return BaseUnits.Battery

    case 'Temperature':
      return BaseUnits.Temperature

    case 'Messages':
      return BaseUnits.Message

    default:
      return BaseUnits.Unknown
  }
}
